import React, {useState} from "react";
import './MainMenu.css';
import MobiusTraderLogo from "../../../../static/img/Terminal/menuTerminal/mobiusLogo.svg";
import ChangeLink from "../../../ChangeLink/ChangeLink";
import MainMenuArray from "./MainMenuArray";
import ChangeNavLink from "../../../ChangeNavLink/ChangeNavLink";

function MainMenu(props){
    const [Active, setActive] = useState(props.Active);
    const [AllMenu, setAllMenu] = useState(props.AllMenu);

    const SubmenuWork = (Submenu,lang) => { // Правила по которым создается новый массив при окончании перемещения элементов мышкой
        const result = Array.from(Submenu);
        return result.map(function(SubMenuElement,index) {
            if (SubMenuElement.type === 'trader_new') {
                return (
                    <div className='MainMenuElementOut MainMenuElementOutTraderNew ' key={index}>
                        <ChangeNavLink lang={props.lang} ActiveClass='MainMenuElementActive' key={index}
                                    to={SubMenuElement.href} style={{textDecoration: 'none'}}>
                            <div className='MainSubMenuElement '>{SubMenuElement.Name[lang]}</div>
                        </ChangeNavLink>
                    </div>
                )
            } else {
                if (SubMenuElement.type === 'terminal') {
                    return (
                        <ChangeNavLink lang={props.lang} key={index} to={SubMenuElement.href} style={{textDecoration: 'none'}}
                                       ActiveClass="MainMenuElementActiveNow">
                            <div className='MenuElementTerminal'>
                                <div className='MenuElementTerminalDiv'>
                                    <img alt='alt' className='MenuElementTerminalDivImg' src={SubMenuElement.IfIMG}
                                         width={SubMenuElement.width} height={SubMenuElement.height}/>
                                    <img alt='alt' className='MenuElementTerminalDivImgActive'
                                         src={SubMenuElement.IfIMGActive} width={SubMenuElement.width}
                                         height={SubMenuElement.height}/>
                                    <div className='MenuElementTerminalDivLabel'>
                                        {SubMenuElement.Name[lang]}
                                    </div>
                                </div>
                            </div>
                        </ChangeNavLink>
                    )
                } else {
                    //console.log('SubMenuElement');
                    return (
                        <div className='MainMenuElementOut' key={index}>
                            <ChangeNavLink lang={props.lang} ActiveClass='MainMenuElementActive' key={index} to={SubMenuElement.href} style={{textDecoration: 'none'}}>
                                <div className='MainSubMenuElement '>{SubMenuElement.Name[lang]}</div>
                            </ChangeNavLink>
                        </div>
                    )
                }
            }
        });};

    const topMenu = (ActiveElement,self,lang,AllMenu) => MainMenuArray.map(function(MenuElement,index) {
        //console.log('MainMenuArray555',AllMenu,ActiveElement)
        // let typeOfMenu = 'MainMenuHeader';
        // if (MenuElement.Submenu[0].Name['ru'] === 'Windows') {typeOfMenu = 'MainMenuHeader MainMenuHeaderTerminal'}
        if (index===ActiveElement) {
            return (
                <div key={index} className={AllMenu[index]}>
                    <div className={AllMenu[index]}   onClick={() => SelectMenu(index+1)} role = "button" tabIndex={0}><nobr >{MenuElement.Name[lang]} </nobr></div>
                    {/*<div className={typeOfMenu}>*/}
                    {/*    {SubmenuWork(MenuElement.Submenu,lang)}*/}
                    {/*</div>*/}
                </div>
            )
        } else  return (
            <div key={index} className={AllMenu[index]}>
                <div  className='MainMenuElement ' onClick={() => SelectMenu(index+1)} role = "button" tabIndex={0}><nobr >{MenuElement.Name[lang]} </nobr></div>
                {/*<div className={typeOfMenu + " " + MenuElement.type}>*/}
                {/*    {SubmenuWork(MenuElement.Submenu,lang)}*/}
                {/*</div>*/}
            </div>
        )}

    );

    function SelectMenu(updateText){
        //console.log('updateText444',updateText);
        const  AllMenu = ['','','','','',''];
        AllMenu[updateText-1] = 'ElementMenuActive';
        setAllMenu(AllMenu);
        setActive(updateText-1);
    };

        //console.log('MainMenuArray',MainMenuArray[Active].Submenu);
        if (MainMenuArray[Active].Submenu[0].Name['ru'] === 'Windows') {
            return (
                <div className="MainMenu">
                    <div className="MainMenuTop">
                        {topMenu(Active,props,props.lang,AllMenu)}
                    </div>
                    <div className="MainMenuSubTerminal">
                        <img alt='alt' className='' src={MobiusTraderLogo} width={'95px'} height={'25px'}/>
                        {SubmenuWork(MainMenuArray[Active].Submenu,props.lang)}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="MainMenu">
                    <div className="MainMenuTop">
                        {topMenu(Active,props,props.lang,AllMenu)}
                    </div>
                    <div className="MainMenuSub">

                        {SubmenuWork(MainMenuArray[Active].Submenu,props.lang)}
                    </div>
                </div>
            )
        }

        }

export default MainMenu